import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import * as sTypes from 'Flow2/components/Share/ShareTypes/ShareTypes';
import Dropdown from "Flow2/components/AdvancedBox/AdvancedUI/Dropdown/Dropdown";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import HelpDialog from 'Flow2/components/AdvancedBox/AdvancedUI/HelpDialog/HelpDialog';
import './FlexDate.scss';

const FlexDate = (props) => {
    const [userInputs, setUserInputs] = useState({});
    const [data, setData] = useState([]);
    const [isDisabled, setIsDiabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [curDD, setCurDD] = useState(null);
    const [isOpened, setIsOpened] = useState(false);
    const fm = ({ id }) => props.intl.formatMessage({ id });


    useEffect(() => {
        setData([...sTypes.FLEX_DATE_DATA]);
    }, []);


    const checkReqOthers = ({ elem, nErrors, subEl }) => {
        subEl.reqOthers.forEach(check => {
            if (userInputs[elem.name] && userInputs[elem.name][check]
                && parseInt(userInputs[elem.name][check])) {
                nErrors = { ...nErrors, [elem.name]: { ...nErrors[elem.name], [check]: false } };
            } else {
                nErrors = { ...nErrors, [elem.name]: { ...nErrors[elem.name], [check]: true } };
            }
        })
        return nErrors;
    }

    const clearReqOthers = ({ nErrors, elem, subEl }) => {
        subEl.reqOthers.forEach(check => {
            if (nErrors[elem.name] && nErrors[elem.name][check]) {
                nErrors = { ...nErrors, [elem.name]: { ...nErrors[elem.name], [check]: false } };
            }
        });
        return nErrors;
    }

    const getErrors = ({ nErrors, entry, subEl, eValue }) => {
        nErrors = { ...nErrors, [entry.name]: { ...nErrors[entry.name], [subEl.name]: eValue } };
        return nErrors;
    }

    const checkReqLen = ({ elem, subEl, nErrors, updatedObj }) => {
        if (updatedObj[elem.name] && updatedObj[elem.name][subEl.name]
            && updatedObj[elem.name][subEl.name].length != subEl.reqLen) {
            nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: true });
        } else {
            nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: false });
        }
        return nErrors;
    }


    const checkReqMax = ({ elem, subEl, nErrors, updatedObj }) => {
        if (updatedObj[elem.name] && updatedObj[elem.name][subEl.name]
            && parseInt(updatedObj[elem.name][subEl.name]) > subEl.reqMax) {
            nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: true });
        } else {
            nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: false });
        }
        return nErrors;
    }

    const checkHasErrors = ({ nErrors }) => {
        let hasErrors = false;
        Object.keys(nErrors).forEach(err => {
            if (nErrors[err]) {
                if (Object.keys(nErrors[err]).some(e => nErrors[err][e])) {
                    hasErrors = true;
                }
            }
        })
        return hasErrors;
    }

    const handleRow = ({ obj, nErrors, elem, updatedObj }) => {
        obj[elem.name] = {};
        elem.data.forEach(subEl => {
            obj[elem.name][subEl.name] = 0;
            if (updatedObj[elem.name] && updatedObj[elem.name][subEl.name]) {
                if (updatedObj[elem.name][subEl.name]) {
                    if (parseInt(updatedObj[elem.name][subEl.name])) {
                        if (subEl.reqLen) nErrors = checkReqLen({ subEl, elem, nErrors, updatedObj });
                        if (subEl.reqMax) nErrors = checkReqMax({ subEl, elem, nErrors, updatedObj });
                        if (subEl.reqOthers) nErrors = checkReqOthers({ subEl, elem, nErrors });
                        obj[elem.name][subEl.name] = parseInt(updatedObj[elem.name][subEl.name]);
                    } else {
                        nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: true });
                    }
                }
            } else if (updatedObj[elem.name] && updatedObj[elem.name][subEl.name] == '') {
                if (subEl.reqOthers) nErrors = clearReqOthers({ nErrors, elem, subEl });
                if (curDD && curDD.reqOthers) {
                    if (curDD.reqOthers.indexOf(subEl.name) > -1) {
                        nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: true });
                    }
                }
                if (subEl.checkOthers && subEl.checkOthers.some(so => updatedObj[elem.name][so])) {
                    nErrors = getErrors({ nErrors, entry: elem, subEl, eValue: true });
                }
            }
        });
        return { obj, nErrors };
    }

    const handleDD = ({ elem, cur, updatedObj, obj, nErrors, nData }) => {
        obj[elem.name] = "";
        let first = false;
        if (updatedObj[elem.name]) obj[elem.name] = updatedObj[elem.name];
        if (cur && cur.value !== sTypes.XX) {
            nData.forEach(entry => {
                if (entry.type === sTypes.ROW) {
                    if (entry.data && entry.data && !first) {
                        entry.data.forEach(subEl => {
                            let indexOf = cur.reqOthers.indexOf(subEl.name);
                            if (indexOf > -1) {
                                if (updatedObj[entry.name] && updatedObj[entry.name][subEl.name]) {
                                    nErrors = getErrors({ nErrors, entry, subEl, eValue: false });
                                } else {
                                    nErrors = getErrors({ nErrors, entry, subEl, eValue: true });
                                }
                            }
                            first = true;
                        });
                    }
                }
            })
        }
        return { obj, nErrors };
    }

    const setValues = ({ entry, el, value, cur, nData }) => {
        let updatedObj = { ...userInputs };
        if (entry && el) {
            updatedObj[entry.name] = { ...userInputs[entry.name], [el.name]: value }
        }
        if (entry && cur) updatedObj = { ...userInputs, [entry.name]: cur.value };
        setUserInputs(updatedObj);
        checkUpdate({ updatedObj, cur, nData });
    }

    const onRowChange = ({ e, entry, el }) => {
        const { value, name } = e.target;
        let nData = data;
        setValues({ entry, el, value, nData });
    }

    const onDDClick = ({ entry }) => (cur) => {
        let nData = [...sTypes.FLEX_DATE_DATA];
        if (cur.disableLine) {
            setIsDiabled(true);
            nData = nData.filter(el => !el.disLine);
        }
        else setIsDiabled(false);
        setData(nData);
        setValues({ entry, cur, nData });
        setCurDD(cur);
    }

    const setFormData = ({ nData, nErrors, obj }) => {
        let curErrors = {};
        let curObj = {};
        nData.forEach(real => {
            if (nErrors[real.name]) curErrors[real.name] = nErrors[real.name];
            if (obj[real.name]) curObj[real.name] = obj[real.name];
        });
        if (nData.length == 2) curObj = { ...curObj, ...sTypes.EMPTY_OBJ };
        let hasErrors = checkHasErrors({ nErrors: curErrors });
        setErrors(curErrors);
        props.onFlexDate({ name: props.item.name, date: curObj, hasErrors });
    }

    const checkUpdate = ({ updatedObj, cur, nData }) => {
        let obj = {};
        let nErrors = { ...errors };
        nData.forEach(elem => {
            let res;
            if (elem.type === sTypes.DD) {
                res = handleDD({ obj, nErrors, elem, updatedObj, cur, nData });
            }
            if (elem.type === sTypes.ROW) {
                res = handleRow({ obj, nErrors, elem, updatedObj, nData });
            }
            obj = res.obj;
            nErrors = res.nErrors;
        });
        setFormData({ nData, nErrors, obj });
    }


    const showDD = ({ entry }) => {
        if (entry.data && entry.data) {
            return (
                <div className="flexdata-dd-box">
                    <div className="flexdata-dd">
                        <Dropdown data={entry.data}
                            current={userInputs[entry.name] ? userInputs[entry.name] : ''}
                            required={false} error={false}
                            onDDClick={onDDClick({ entry })} />
                    </div>
                </div>
            )
        }
    }

    const showRow = ({ entry, idx }) => {
        if (entry.data && entry.data) {
            return (
                <div className={`flexdate-row ${(idx == 1 && isDisabled) ? 'flexdate-disabled' : ''}`}>
                    {entry.data.map(el => <input type='text' placeholder={fm({ id: el.intl })}
                        onChange={(e) => onRowChange({ e, entry, el })}
                        className={`${(errors[entry.name] && errors[entry.name][el.name]) ? 'flexdate-error' : ''}`}
                        value={userInputs[entry.name] && userInputs[entry.name][el.name] ? userInputs[entry.name][el.name] : ''} />)}
                </div>
            )
        }
    }

    return (
        <div className={`flexdata ${props.requiredField ? 'flexdata-required' : ''}`}>
            <div className="flexdata-first">
                <div>{fm({ id: props.fMsgId })}{props.mandatory && <span>*</span>}
                    <span onClick={() => setIsOpened(true)}><FontAwesomeIcon icon={faQuestion} /></span>
                </div>
                {data.map(entry => {
                    if (entry.type === sTypes.DD) return showDD({ entry })
                })}
            </div>
            <div className="flexdata-second">
                {data.map((entry, idx) => {
                    if (entry.type === sTypes.ROW) return showRow({ entry, idx });
                })}
            </div>
            {isOpened && <HelpDialog isOpened={isOpened} onClose={() => setIsOpened(false)} isUpQ={true} />}
        </div>
    )
}

export default injectIntl(FlexDate);